// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","SubscribedPhotoblogs":"tb_a bht_b bht_bj","SubscribedPhotoblogs__link":"tb_b bht_a bht_r"};